import React, { useEffect, useState, useRef } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { FaEdit } from 'react-icons/fa'
import { IoAddCircleOutline, IoRemoveCircle } from 'react-icons/io5'

import useCommonAPI from 'Shared/API/Common'

import PopupModal from 'Shared/Components/PopupModal'
import DataTable from 'Shared/Components/DataTable'
import WorkerForm from './compoennts/WorkerForm'

const Workers = () => {
  const { role, setPageLoading } = useOutletContext()
  const { getWorkers } = useCommonAPI()

  const { t } = useTranslation()

  const [workers, setWorkers] = useState({})

  const [formOpen, setFormOpen] = useState({
    "mode": null,
    "values": null
  })

  const tableRef = useRef()

  const filterRef = useRef({
    "search": ""
  })

  const loadData = async () => {
    const [workers] = await Promise.all([
      getWorkers({
        search: filterRef.current.search,
        offset: (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
        limit: tableRef.current.getState()["itemsPerPage"]
      }, 1)
    ])

    workers && setWorkers({
      "data": workers["data"],
      "count": Math.ceil(workers["count"]/tableRef.current.getState()["itemsPerPage"])
    })
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await loadData()

      setPageLoading(false)
    }

    init()
  }, [])

  const toggleForm = (mode, values) => {
    setFormOpen({
      "mode": mode,
      "values": values
    })
  }

  const reloadData = async () => {
    tableRef.current.setTableLoading(true)

    await loadData()

    tableRef.current.setTableLoading(false)
  }

  const onSearch = async (value) => {        
    filterRef.current.search = value

    await reloadData()
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={workers["data"]} count={workers["count"]} loadData={() => reloadData()} ref={tableRef} onSearch={onSearch}
              columns={{
                "worker_name": { "label": t("general_workerName"), "sorting": false, "nowrap": true },
                "title": { "label": t("workers_title"), "sorting": false, "nowrap": true },
                "company": { "label": t("workers_company"), "sorting": false, "nowrap": true },
              }}
              appActions={() => { return [
                (["pm", "admin"].includes(role)) && {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { toggleForm("create") }}
              ]}}
              renderActions={(row) => { return [
                (["pm", "admin"].includes(role)) && {icon: <FaEdit size={20}/>, text: t("general_edit"), onClick: function(row) { toggleForm("edit", row) }},
                (["pm", "admin"].includes(role)) && {icon: <IoRemoveCircle size={20}/>, text: t("general_remove"), onClick: function(row) { toggleForm("delete", row) }}
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 
    
    <PopupModal isOpen={formOpen["mode"] != null} close toggle={() => toggleForm()} width="80%">
      <WorkerForm mode={formOpen["mode"]} data={formOpen["values"]} reloadData={reloadData} toggleForm={toggleForm}/>
    </PopupModal>
  </>)
}

export default Workers
